export enum ServiceStatus {
  PENDING = 1,
  APPROVED = 2,
  REJECTED = 3,
  REPORTED = 4,
  DELETED = 5,
  DRAFT = 6,
  PURCHASED = 7,
}

export interface ServiceModel {
  _id: string;
  userId: string; // Created By
  title: string;
  category: {
    id?: string;
    name?: string;
    icon?: string;
  };
  subCategory: {
    id?: string;
    name?: string;
  };
  skills: string[];
  priceAndPackages: ServiceModelPackage[];
  images: string[];
  description?: string;
  questionnaire: {
    question?: string;
    answer?: string;
  }[];
  requirement: {
    question?: string;
    answerType: {
      type?: "freeText" | "multipleChoice" | "file";
      multipleChoice?: {
        choice?: string[];
        allowMoreAnswers?: boolean;
      };
    };
    required?: boolean;
  }[];
  status?: ServiceStatus;
  deleteInfo?: {
    isDelete?: boolean;
    deleteDate?: Date;
  };
  report: {
    reportedBy?: string; // Reported By
    reportReason?: string;
    reportDescription?: string;
  }[];
  showOnProfile?: boolean;
  createdAt?: Date;
}

export type ServiceModelPackage = {
  _id: string;
  enabled?: boolean;
  name?: string;
  description?: string;
  revisions?: string;
  extraServices?: {
    name?: string;
    included?: boolean;
  }[];
  requiredDays: number;
  requiredTime: {
    count: number;
    countType: "DAYS" | "WEEKS" | "MONTHS";
  };
  price: number;
};
